module.exports = __webpack_public_path__ + "img/keji_fuwu.4df2cfc1.png";